/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Work_0_DescInputs */

const en_svc_ai_app_rescue_work_0_desc = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A stuck community build fixed, hardened and shipped: auth, live leaderboards and real-time updates in production.`)
};

const ar_svc_ai_app_rescue_work_0_desc = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بناء مجتمعي متعثر أُصلح وحُصّن وأُطلق: مصادقة ولوحات مباشرة وتحديثات فورية في الإنتاج.`)
};

const bn_svc_ai_app_rescue_work_0_desc = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আটকে যাওয়া কমিউনিটি বিল্ড ঠিক, শক্ত আর লঞ্চ করা: প্রোডাকশনে অথ, লাইভ লিডারবোর্ড আর রিয়েল-টাইম আপডেট।`)
};

const de_svc_ai_app_rescue_work_0_desc = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein festgefahrener Community-Build, repariert, gehärtet und geliefert: Auth, Live-Bestenlisten und Echtzeit-Updates in Produktion.`)
};

const es_svc_ai_app_rescue_work_0_desc = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un desarrollo comunitario atascado, reparado, endurecido y lanzado: autenticación, rankings en vivo y actualizaciones en tiempo real en producción.`)
};

const fr_svc_ai_app_rescue_work_0_desc = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un build communautaire bloqué, réparé, durci et lancé : authentification, classements en direct et mises à jour temps réel en production.`)
};

const pt_svc_ai_app_rescue_work_0_desc = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um desenvolvimento comunitário encravado, reparado, endurecido e lançado: autenticação, tabelas em direto e atualizações em tempo real em produção.`)
};

const zh_svc_ai_app_rescue_work_0_desc = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卡住的社区项目被修好、加固并上线：登录、实时榜单和实时更新都在生产环境跑着。`)
};

const tr_svc_ai_app_rescue_work_0_desc = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takılmış topluluk derlemesi düzeltildi, sertleştirildi, yayınlandı: üretimde kimlik doğrulama, canlı liderlik tabloları ve gerçek zamanlı güncellemeler.`)
};

const ru_svc_ai_app_rescue_work_0_desc = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Застрявшая community-сборка починена, закалена и запущена: авторизация, живые лидерборды и реалтайм-апдейты в проде.`)
};

const pl_svc_ai_app_rescue_work_0_desc = /** @type {(inputs: Svc_Ai_App_Rescue_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zablokowany build społecznościowy naprawiony, utwardzony i wypuszczony: logowanie, żywe rankingi i aktualizacje w czasie rzeczywistym na produkcji.`)
};

/**
* | output |
* | --- |
* | "A stuck community build fixed, hardened and shipped: auth, live leaderboards and real-time updates in production." |
*
* @param {Svc_Ai_App_Rescue_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_work_0_desc = /** @type {((inputs?: Svc_Ai_App_Rescue_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_work_0_desc(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_work_0_desc(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_work_0_desc(inputs)
	return en_svc_ai_app_rescue_work_0_desc(inputs)
});
export { svc_ai_app_rescue_work_0_desc as "svc_ai-app-rescue_work_0_desc" }